import { useState, useEffect } from 'react';
import Axios from "axios";
import {  AddMatchedcandidateList, GenerateContent,  Searchfilter, SendMatchEmail } from '../apiconstants/constants';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import ReactPaginate from "react-paginate";
import nodataimg from "../assets/images/Nodata.jpg";
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import LoadingSpinner from '../helpers/loadingspinner';
import ConsultantLayout from '../commonlayouts/consultantlayout';
import * as pdfjsLib from "pdfjs-dist";
import stringSimilarity from "string-similarity";
import Mammoth from "mammoth";
import Swal from 'sweetalert2';
import { Modal, Button, Form } from "react-bootstrap";
import axios from 'axios';
import { useCountry } from '../contexts/countrycodecontext.js';
pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;

function substring_str(str) {
  if ((str === null) || (str === ' ' || str === undefined))
    return "";
  else
    str = str.toString();
  return str.substring(0, 100) + "...";
}

const stripHtml = (html) => {
    const doc = new DOMParser().parseFromString(html, "text/html");
    return doc.body.textContent || "";
};
const ViewMatchedCandidates = () => {
    const location = useLocation();
    const navigate =  useNavigate();
    const jobDescription = location.state?.jobDescription;
    const jobPostID = location.state?.jobPostID;
  const jobRoleId = location.state?.jobRoleID;
  console.log("36",jobRoleId)
  const clientEmail = location.state?.clientEmail;
  const clientName = location.state?.clientName;
  const jobPlainText = stripHtml(jobDescription).toLowerCase();
  const updatedDate = location.state?.updatedDateFilter;
  const [offset, setOffset] = useState(0);
  const [data, setData] = useState([]);
  const [perPage] = useState(25);
  const [pageCount, setPageCount] = useState(0);
  const [candidateData, setCandidateData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState(""); // Search term state
  const [startDate, setStartDate] = useState(""); // Start date state
  const [endDate, setEndDate] = useState(""); // End date state
  const [showModal, setShowModal] = useState(false);
  const [showCheckboxModal, setShowCheckboxModal] = useState(false);
  const [selectedClientEmail, setSelectedClientEmail] = useState("");
  const [selectedData, setSelectedData] = useState(null);
  const [selectedItems, setSelectedItems] = useState([]);
  const clientData = JSON.parse(localStorage.getItem("clientData"));
  const [showIcon, setShowIcon] = useState('list');
  const [viewType, setViewType] = useState('list'); // 'grid' or 'list'
  const token = localStorage.getItem('jwtToken');
  const [showAnalyzeMoreModal, setShowAnalyzeMoreModal] = useState(false);
  const [showcolumn, setShowColumn] = useState(false);
  const [isAnalyzing, setIsAnalyzing] = useState(false);
  const { selectedCountry} = useCountry();
  const handlePageClick = (e) => {
    const selectedPage = e.selected;
    setOffset(selectedPage * perPage);
  };
  const handleViewToggle = (type) => {
    setViewType(type);
    setShowIcon(type)
  };
  

let Guid="";

const guid = localStorage.getItem("guid");
const employerGuid = localStorage.getItem("employerGuid")

const roleID = localStorage.getItem("roleID")

if(roleID==3){
 Guid = employerGuid
}
else{
  Guid= guid
}
const handleClose = () => setShowModal(false);
useEffect(() => {
  GetCandidateList();
}, [selectedCountry]);

const handleSubmitEmail = async () => {
  console.log("data",selectedData)
  const params = {
    resume:null,
    resumeSkills: selectedData?.extractedResumeSkills?.toString(),
    jdSkills: selectedData?.extractedPostJobResults?.toString(),
    senderEmail: selectedClientEmail, // Updated Email from input field
    matchedSkills: selectedData?.finalMatchedSkills?.toString(),
    matchedSkillsPercentage: selectedData?.matchedSkillsPercentage 
    ? selectedData.matchedSkillsPercentage.toString() + '%' 
    : '0%',
   candidatesCertifications: selectedData?.candidateCertifications,
    matchedCertifications: selectedData.macthedCertificationAnalysisResults,
    matchedKeyResponsibilitiesReason: selectedData?.extractedResponsibilitiesResults?.reasons,
    jobpostID: jobPostID,
    candidateID: selectedData.candidatesID,
    senderName: clientName,
    companyName:clientData.companyName
  };

  Axios.post(SendMatchEmail.APIURL, params,
    { headers: { 'Authorization': `Bearer ${token}` } }
  )
    .then((result) => {
      if (result.data == "Email sent successfully") {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Email sent successfully",
          showConfirmButton: false,
          timer: 5000,
        });
      } 
    })
    .catch((error) => {
      setIsLoading(false);
      console.log("Error" + error);
    });

  handleClose();
};


const analyzetextareaSkill = async (jobPlainText) => {
   try {
        const response = await axios.post(
        GenerateContent.APIURL,
          {
              prompt: `Extract all skills from the following text. Follow these guidelines:
  
                      1. *Extract All Skills:*  
                        - Extract all skills explicitly listed under the "Skills" or "Technical Skills" section.  
                        - Also extract any additional skills mentioned under other sections such as experience, projects, certifications, education, or achievements.  
                        - Capture programming languages, frameworks, tools, platforms, DevOps tools, business skills, and industry-specific skills.  
  
                      2. *Hidden and Embedded Skills:*  
                        - If a skill is mentioned within a sentence or as part of a project description, extract it.  
                        - Example: "Worked on Docker for containerization" → Extract *Docker* as a skill.  
  
                      3. *Normalization:*  
                        - If the skill is mentioned under a different name or alias, normalize it to the standard term (e.g., “Azure Databricks” → “Databricks”, “Microsoft Azure” → “Azure”).  
  
                      4. *DevOps and Monitoring Tools:*  
                        - Ensure DevOps tools like *Jenkins*, *Terraform*, *Docker*, *CI/CD*, and monitoring tools like *Grafana* and *Prometheus* are included if present.  
  
                      5. *Format Output:*  
                        - Return a single, comma-separated list of all extracted skills (including both explicitly listed and inferred skills).  
                        - Remove duplicates and ensure consistent formatting.  
  
                      6. *Retry and Match:*  
                        - If the skills section is missing or unclear, attempt to extract skills from other sections or provide the closest possible match.  
                        - If you suspect that some skills were not captured, retry extraction automatically.  
  
                      7. *Exclude:*  
                        - Exclude soft skills (e.g., communication, leadership, problem-solving).  
                        - Exclude job responsibilities and achievements.  
                        - Exclude processes (e.g., Agile, Performance Tuning, Cost Optimization).  
  
                      ### Examples of Expected Skills:
                      - Programming: Python, Java, C++, SQL  
                      - Platforms: AWS, Azure, GCP, Kubernetes  
                      - DevOps: Jenkins, Docker, Terraform, Grafana  
                      - Data Tools: Spark, Hive, Snowflake, Databricks  
                      - Industry Skills: Financial Analysis, Healthcare Compliance 
                      
                      text:
                      ${jobPlainText}`,
          },
          { headers: {
            'Content-Type': 'application/json',
            'accept': '*/*',
            'Authorization': `Bearer ${token}` // Add the Authorization header       
             }}
      );
  
      console.log("API Response:", response);
  
      const responseContent = response.data?.response?.candidates?.[0]?.content?.parts?.[0]?.text || "";
      const  extractedTextSkills = (responseContent.split(",").map((skill) => skill.trim()));
    return extractedTextSkills
  } catch (err) {
       if (err.response && err.response.status === 401) {
                  Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Session expired! Please Login again',
                    showConfirmButton: false,
                    timer: 5000,
                  }); 
                  setTimeout(() => {
                    window.location.href = "/Login"; // Redirect to login page
                  }, 5000);
                  return;
                }
    setIsLoading(false);
    console.error("Error extracting skills:", err);
  }
};

  const analyzeSkill = async (resumeText) => {
 
    try {
      const response = await axios.post(
    GenerateContent.APIURL,
    {
        prompt:`Extract all skills from the following text. Follow these guidelines:

                1. *Extract All Skills:*  
                  - Extract all skills explicitly listed under the "Skills" or "Technical Skills" section.  
                  - Also extract any additional skills mentioned under other sections such as experience, projects, certifications, education, or achievements.  
                  - Capture programming languages, frameworks, tools, platforms, DevOps tools, business skills, and industry-specific skills.  

                2. *Hidden and Embedded Skills:*  
                  - If a skill is mentioned within a sentence or as part of a project description, extract it.  
                  - Example: "Worked on Docker for containerization" → Extract *Docker* as a skill.  

                3. *Normalization:*  
                  - If the skill is mentioned under a different name or alias, normalize it to the standard term (e.g., “Azure Databricks” → “Databricks”, “Microsoft Azure” → “Azure”).  

                4. *DevOps and Monitoring Tools:*  
                  - Ensure DevOps tools like *Jenkins*, *Terraform*, *Docker*, *CI/CD*, and monitoring tools like *Grafana* and *Prometheus* are included if present.  

                5. *Format Output:*  
                  - Return a single, comma-separated list of all extracted skills (including both explicitly listed and inferred skills).  
                  - Remove duplicates and ensure consistent formatting.  

                6. *Retry and Match:*  
                  - If the skills section is missing or unclear, attempt to extract skills from other sections or provide the closest possible match.  
                  - If you suspect that some skills were not captured, retry extraction automatically.  

                7. *Exclude:*  
                  - Exclude soft skills (e.g., communication, leadership, problem-solving).  
                  - Exclude job responsibilities and achievements.  
                  - Exclude processes (e.g., Agile, Performance Tuning, Cost Optimization).  

                ### Examples of Expected Skills:
                - Programming: Python, Java, C++, SQL  
                - Platforms: AWS, Azure, GCP, Kubernetes  
                - DevOps: Jenkins, Docker, Terraform, Grafana  
                - Data Tools: Spark, Hive, Snowflake, Databricks  
                - Industry Skills: Financial Analysis, Healthcare Compliance 
Resume:
${resumeText}`,
    },
    { headers: {
      'Content-Type': 'application/json',
      'accept': '*/*',
      'Authorization': `Bearer ${token}` // Add the Authorization header       
       }}
);

console.log("API Response:", response);

const responseContent = response.data?.response?.candidates?.[0]?.content?.parts?.[0]?.text || "";
 const extractedSkills = responseContent.split(",").map((skill) => skill.trim());
      return extractedSkills;
    } catch (err) {
         if (err.response && err.response.status === 401) {
                    Swal.fire({
                      position: 'center',
                      icon: 'error',
                      title: 'Session expired! Please Login again',
                      showConfirmButton: false,
                      timer: 5000,
                    }); 
                    setTimeout(() => {
                      window.location.href = "/Login"; // Redirect to login page
                    }, 5000);
                    return;
                  }
      setIsLoading(false);
      console.error("Error extracting skills:", err);
    }
  };
  
  

const analyzeResume = async (resumeText, jobPlainText) => {  
  try {
    const response = await axios.post(
      GenerateContent.APIURL,
      {
          prompt: `You are an expert resume analysis engine.

          Analyze the following **Resume** and **Job Description**, and provide **6 to 7 bullet points** (as a JSON array of strings) that summarize the **key strengths, relevant certifications or learning efforts**, and **gaps in skills or responsibilities** based on the comparison.
          
          ### Guidelines:
          - Focus on specific technical responsibilities or certifications that align with the job description.
          - Include any learning effort or familiarity that could be considered positive, even if there's no formal experience.
          - Highlight any clear skill or experience gaps relevant to the job.
          - Do not include generic statements like "good fit" or "not suitable".
          - Each point must be concise and technically specific.
          - Return **only a valid JSON array of strings**. No markdown or extra explanation.
          
          ### Resume:
          ${resumeText}
          
          ### Job Description:
          ${jobPlainText}
          
          ### Output Format:
          [
            "Point 1",
            "Point 2",
            "Point 3",
            "Point 4",
            "Point 5",
            "Point 6",
            "Point 7"
          ]`
      },
      { headers: {
        'Content-Type': 'application/json',
        'accept': '*/*',
        'Authorization': `Bearer ${token}` // Add the Authorization header       
         }}
  );
     const rawText = response.data?.response?.candidates?.[0]?.content?.parts?.[0]?.text || "";
    const cleaned = rawText.replace(/```json\s*|```/g, "").trim();
  
    const parsed = JSON.parse(cleaned);
    const reasonList = parsed
      .map((item, index) => ({
        reasonId: index + 1,
        reason: item.trim(),
      }))
      .filter(item => item.reason !== "");
    return {
      reasons: reasonList,
    };

  } catch (err) {
    setIsLoading(false);
       if (err.response && err.response.status === 401) {
                  Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Session expired! Please Login again',
                    showConfirmButton: false,
                    timer: 5000,
                  }); 
                  setTimeout(() => {
                    window.location.href = "/Login"; // Redirect to login page
                  }, 5000);
                  return;
                }
    console.error("Error calling AI API:", err);
    return {
      matchPercentage: 0,
      reasons: [{ reasonId: 0, reason: "Error processing request" }],
    };
  }
};

const getFileExtension = (fileUrl) => {
  return fileUrl.split('.').pop().toLowerCase();
};

const extractTextFromFile = async (fileUrl) => {
  const fileType = getFileExtension(fileUrl);

  if (fileType === "pdf") {
    return extractTextFromPDF(fileUrl);
  } else if (fileType === "docx") {
    return extractTextFromDocx(fileUrl);
  }else {
    console.error("Unsupported file type:", fileType);
    return "Unsupported file type.";
  }
};

const extractTextFromPDF = async (fileUrl) => {
  try {
    const response = await Axios.get(fileUrl, { responseType: "arraybuffer" });
    const pdf = await pdfjsLib.getDocument({ data: response.data }).promise;
    let extractedText = "";

    for (let i = 1; i <= pdf.numPages; i++) {
      const page = await pdf.getPage(i);
      const textContent = await page.getTextContent();
      extractedText += textContent.items.map((item) => item.str).join(" ") + "\n";
    }

    return extractedText;
  } catch (error) {
    setIsLoading(false);
    console.error(`❌ Error extracting text from PDF:`, error);
    return "Failed to extract text from PDF.";
  }
};
const extractTextFromDocx = async (fileUrl) => {
  try {
    const response = await Axios.get(fileUrl, { responseType: "blob" });
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = async () => {
        try {
          const { value: extractedText } = await Mammoth.extractRawText({
            arrayBuffer: reader.result,
          });
          resolve(extractedText); // ✅ Return extracted text
        } catch (err) {
          setIsLoading(false);
          console.error("Error extracting text:", err);
          reject("Failed to extract text.");
        }
      };

      reader.onerror = () => {
        console.error("Error reading file.");
        reject("Error reading file.");
      };

      // 2️⃣ Convert Blob to ArrayBuffer
      reader.readAsArrayBuffer(response.data);
    });
  } catch (error) {
    setIsLoading(false);
    console.error("Error fetching the file:", error);
    return "Error fetching file.";
  }
};


const   extractCandidateCertifications = async (text) => {
  try {
    const response = await Axios.post(
   GenerateContent.APIURL,
   {
    prompt: `Extract all certifications mentioned in this resume text. 
      Return only a comma-separated list of certifications without extra text:\n\n${text}`,
},
{ headers: {
  'Content-Type': 'application/json',
  'accept': '*/*',
  'Authorization': `Bearer ${token}` // Add the Authorization header       
   }}
    );

    console.log("API Response:", response);

    const responseContent = response.data?.response?.candidates?.[0]?.content?.parts?.[0]?.text || "";
   
      if (!responseContent) {
          console.warn("Response content is empty, no certifications extracted.");
          return [{ certificationId: 0, certificationName: "No certifications found" }];
      }

      const certMatches = responseContent.split(",").map((cert) => cert.trim()).filter(cert => cert);

      if (certMatches.length === 0) {
          console.warn("No valid certifications extracted.");
          return [{ certificationId: 0, certificationName: "No certifications found" }];
      }

      // Convert to required format
      const formattedCertifications = certMatches.map((cert, index) => ({
          certificationId: index + 1,
          certificationName: cert
      }));

      return formattedCertifications;
  } catch (err) {
    setIsLoading(false);
       if (err.response && err.response.status === 401) {
                  Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Session expired! Please Login again',
                    showConfirmButton: false,
                    timer: 5000,
                  }); 
                  setTimeout(() => {
                    window.location.href = "/Login"; // Redirect to login page
                  }, 5000);
                  return;
                }
      console.error("Error extracting certifications:", err);
      return [{ certificationId: 0, certificationName: "No certifications found" }];
  }
};


const analyzeCertifications = async (resumeText, jobPlainText) => { 
  try {
    const response = await axios.post(
      GenerateContent.APIURL,
      {
          prompt: `### **Task:**  
            1️⃣ Extract only explicit certifications from the resume content.
            2️⃣ Extract only explicit required certifications from the job responsibilities.
            3️⃣ Compare both lists and return only exact matches (no semantic similarity checks).
            
            🔍 Important:
            
            Do not infer or assume certifications based on general skills.
            If no exact certification names match, return: No matched certifications found.
            #### **Resume Content:**  
            ${resumeText}  
            
            #### **Job Responsibilities:**  
            ${jobPlainText}  
            
            ### **Response Format:**  
            **Matched Certifications:**  
            - Certification 1  
            - Certification 2`
      },
      { headers: {
        'Content-Type': 'application/json',
        'accept': '*/*',
        'Authorization': `Bearer ${token}` // Add the Authorization header       
         }}
  );
  const responseContent = response.data?.response?.candidates?.[0]?.content?.parts?.[0]?.text || "";


    // Extract matched certifications using regex
    const matchedCertificationsMatch = responseContent.match(
      /(?<=\*\*Matched Certifications:\*\*\n)([\s\S]*?)(?=\n\n|$)/
    );

    const matchedCertifications = matchedCertificationsMatch
      ? matchedCertificationsMatch[1]
          .split("\n")
          .filter((line) => line.startsWith("- ")) // Keep only list items
          .map((cert) => cert.replace("- ", "").trim()) // Clean up formatting
      : [];

    // Ensure response follows the required format
    return matchedCertifications.length > 0
      ? matchedCertifications.map((cert, index) => ({
          certificationId: index + 1,
          certificationName: cert
        }))
      : [{ certificationId: 0, certificationName: "No matched certifications found" }];
  } catch (err) {
    setIsLoading(false);
       if (err.response && err.response.status === 401) {
                  Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Session expired! Please Login again',
                    showConfirmButton: false,
                    timer: 5000,
                  }); 
                  setTimeout(() => {
                    window.location.href = "/Login"; // Redirect to login page
                  }, 5000);
                  return;
                }
    console.error("Error calling AI API:", err);
    return [{ certificationId: 0, certificationName: "Error processing request" }];
  }
};

 const analyzeResumeWithJD = async (resumeText, jobResponsibilities) => { 
  
    try {
      const response = await axios.post(
        GenerateContent.APIURL,
        {
            prompt: `You are an expert resume analysis engine.
  
  Compare the following **Resume** and **Job Description**, and return a JSON object with exactly the following fields only:
  1. **matchedSkills**: A list of *technical skills* found in both the resume and the job description.
  2. **totalJDskills**: The total number of unique skills extracted from the job description.
  
  ### Resume:
  ${resumeText}
  
  ### Job Description:
  ${jobResponsibilities}
  
  ### Output Format (JSON Only):
  {
    "matchedSkills": ["Skill1", "Skill2"],
    "totalJDskills": 10
  }`,
        },
        { headers: {
          'Content-Type': 'application/json',
          'accept': '*/*',
          'Authorization': `Bearer ${token}` // Add the Authorization header       
           }}
    
    );

    console.log("API Response:", response);

    // Extract response content
    const responseText = response.data?.response?.candidates?.[0]?.content?.parts?.[0]?.text || "";
    console.log("Extracted Text:", responseText);
  
      // Clean up markdown backticks before parsing
      const sanitizeJsonResponse = (text) => {
        return text.replace(/```json\s*|```/g, "").trim();
      };
  
      try {
        const cleanedJson = sanitizeJsonResponse(responseText);
        const parsedJson = JSON.parse(cleanedJson);
  
        // Calculate Matched Skills Percentage
        const matchedSkillsCount = parsedJson.matchedSkills?.length || 0;
        const totalJDskills = parsedJson.totalJDskills || (matchedSkillsCount + (parsedJson.unmatchedSkills?.length || 0));
        // const matchedSkillsPercentage = totalJDskills > 0 ? ((matchedSkillsCount / totalJDskills) * 100).toFixed(2) : "0.00";
    let matchedSkillsPercentage = totalJDskills > 0 
  ? ((matchedSkillsCount / totalJDskills) * 100) 
  : 0;

if (matchedSkillsPercentage > 100) {
  matchedSkillsPercentage = 100;
}

matchedSkillsPercentage = matchedSkillsPercentage.toFixed(2);

        const result = {
          finalMatchedSkills: parsedJson.matchedSkills || [],
          matchedSkillsPercentage: matchedSkillsPercentage
        };

        console.log("Processed Result:", result);
        return result; // ✅ Returning full AI response
  
      } catch (jsonError) {
        console.error("Error parsing JSON response:", jsonError);
        return {
          error: "Failed to parse AI response",
          rawResponse: responseText
        };
      }
    } catch (err) {
         if (err.response && err.response.status === 401) {
                    Swal.fire({
                      position: 'center',
                      icon: 'error',
                      title: 'Session expired! Please Login again',
                      showConfirmButton: false,
                      timer: 5000,
                    }); 
                    setTimeout(() => {
                      window.location.href = "/Login"; // Redirect to login page
                    }, 5000);
                    return;
                  }
      console.error("Error calling AI API:", err);
      return null;
    }
  };
  
  const handleViewCandidate = (data) => {
    navigate(`/Employer/ViewMatchedCandidatebyId?candidateID=${data.candidatesID}&jobPostID=${jobPostID}`, {
      state: {
        jobDescription,
        jobRoleId,
        clientEmail,
        clientName,
        updatedDate,
      },
    });
  };

  
const handleEmailClick = (data) => {
  setSelectedClientEmail(clientEmail);  // Set default email
  setSelectedData(data);               // Store selected candidate data
  setShowModal(true);                  // Open modal
};

const GetCandidateList = async () => { 
  setIsAnalyzing(true);
  setIsLoading(true);

  // Stop analyzing after 5 seconds
  setTimeout(() => {
    setIsAnalyzing(false);
  }, 5000); 

  try {
    const payload = {
      json: JSON.stringify({ UserGuid: Guid ,jobRoleId: jobRoleId,CountryID:selectedCountry,updatedDate:updatedDate}),
      type: "candidatepool",
    };

    const result = await Axios.post(Searchfilter.APIURL, payload,
      { headers: { 'Authorization': `Bearer ${token}` } }
    ); // ✅ Await the Axios call
    const candidates = result.data;
    console.log("Cam", candidates);

    let processedCandidates = [];
    const extractedPostJobResults = await analyzetextareaSkill(jobPlainText);

    for (const candidate of candidates) {
      if (candidate.resume != null) {
        setIsLoading(true);
        const resumeText = await extractTextFromFile(candidate.fileUrl);
        const extractedResumeSkills = await analyzeSkill(resumeText);
        const { finalMatchedSkills, matchedSkillsPercentage } = await analyzeResumeWithJD(
          resumeText,
          jobPlainText
        );

        processedCandidates.push({
          ...candidate,
          resumeText,
          extractedResumeSkills,
          extractedPostJobResults,
          finalMatchedSkills,
          matchedSkillsPercentage,
          extractedResponsibilitiesResults: null,
          macthedCertificationAnalysisResults: null,
          candidateCertifications: null,
        });

      } else {
        setIsLoading(true);
        const extractedResumeSkills = candidate?.technicalSkill;
        const { finalMatchedSkills, matchedSkillsPercentage } = await analyzeResumeWithJD(
          extractedResumeSkills,
          jobPlainText
        );

        processedCandidates.push({
          ...candidate,
          extractedResumeSkills,
          extractedPostJobResults,
          finalMatchedSkills,
          matchedSkillsPercentage,
          extractedResponsibilitiesResults: null,
          macthedCertificationAnalysisResults: null,
          candidateCertifications: null,
        });
      }
    }

    console.log("processedCandidates",processedCandidates);

    const filteredCandidates = processedCandidates
  .filter((candidate) => {
    const matchedSkillsPercentage = candidate?.matchedSkillsPercentage || 0;
    return matchedSkillsPercentage >= 50;
  })
  .sort((a, b) => (b?.matchedSkillsPercentage || 0) - (a?.matchedSkillsPercentage || 0));

setCandidateData(filteredCandidates);
    setIsAnalyzing(false);
    setIsLoading(false);

  } catch (error) {
    console.error("❌ Error fetching candidates:", error);
    setIsLoading(false);
    setIsAnalyzing(false);
  }
};


const handleProceed = async () => {
  setShowAnalyzeMoreModal(false);
  setIsAnalyzing(true);
  setTimeout(() => {
    setIsAnalyzing(false);
  }, 5000);
  setShowColumn(true);
  setIsLoading(true);
  let processedCandidates = [];
  for (const candidate of selectedItems) {
    if (candidate.resume !=null) {
      setIsLoading(true);
      const candidateCertifications =  await extractCandidateCertifications(candidate.resumeText);
      const macthedCertificationAnalysisResults = await  analyzeCertifications(candidate.resumeText,jobPlainText)
      const extractedResponsibilitiesResults = await analyzeResume(candidate.resumeText, jobPlainText);
      processedCandidates.push({
        ...candidate, // Keep existing candidate details
       // resumeText,
       candidateCertifications,
       macthedCertificationAnalysisResults,
       extractedResponsibilitiesResults,
      });
    }
    else if (candidate.resume == null) {
      setIsLoading(true);
      const candidateCertifications =  candidate?.certifications;
      const extractedResumeSkills =  candidate?.technicalSkill;
      const macthedCertificationAnalysisResults = await  analyzeCertifications(candidateCertifications,jobPlainText)
      const extractedResponsibilitiesResults = await analyzeResume(extractedResumeSkills, jobPlainText);
      console.log("569,",extractedResponsibilitiesResults)
      processedCandidates.push({
        ...candidate, // Keep existing candidate details
       candidateCertifications: candidate?.certifications
? [
    {
      certificationId: 1, // Assign a default ID or generate dynamically
      certificationName: candidate.certifications.trim(), // Ensure it's clean
    },
  ]
: [],
        macthedCertificationAnalysisResults,
        extractedResponsibilitiesResults,
      });
    } else {
      processedCandidates.push({
        ...candidate,
        resumeText: "No resume available.",
      });
    }
  }

  
  console.log("processedCandidates",processedCandidates)
  
  const filteredCandidates = processedCandidates.filter((candidate) => {
    const matchedSkillsPercentage = candidate.matchedSkillsPercentage || 0;
  console.log("813 :matchedSkillsPercentage",matchedSkillsPercentage)
    return matchedSkillsPercentage >=50;
  });
    setCandidateData(filteredCandidates);
    setSelectedItems(filteredCandidates);
    setIsAnalyzing(false);
    setIsLoading(false);
}
const handleRemoveCandidate = (guidToRemove) => {
  
  setSelectedItems(prev => prev.filter(item => item.guid !== guidToRemove));
};

const handleCheckboxChange = (data, isChecked) => {
  if (isChecked) {
    setSelectedItems(prev => [...prev, data]);
  } else {
    setSelectedItems(prev => prev.filter(item => item.guid !== data.guid));
  }
};

// Open modal on button click
const openModal = () => {
  setShowCheckboxModal(true);
};
const handleSaveCandidates= async () => {
  // Map each selected item to match the API schema
  const candidates = selectedItems.map(item => ({
    candidateID: item.candidatesID, // or use item.guid if that’s the candidate ID
    resumeSkills: item?.extractedResumeSkills?.toString() || '',
    jdSkills: item?.extractedPostJobResults?.toString() || '',
    matchedSkills: item?.finalMatchedSkills?.toString() || '',
    matchedSkillsPercentage: item?.matchedSkillsPercentage
      ? item.matchedSkillsPercentage.toString() + '%'
      : '0%',
    candidatesCertifications: item?.candidateCertifications || [],
    matchedCertifications: item?.macthedCertificationAnalysisResults || [],
    matchedKeyResponsibilitiesReason: item?.extractedResponsibilitiesResults?.reasons || [],
  }));
  const params = {
    jobpostID: jobPostID,
    candidates: candidates,
    // You can add senderEmail and senderName if your API needs them:
    // senderEmail: selectedClientEmail,
    // senderName: clientName,
  };

  try {
    const result = await Axios.post(AddMatchedcandidateList.APIURL, params,
      { headers: { 'Authorization': `Bearer ${token}` } }
    );
    if (result.data.message === "Candidates List.  added successfully") {
      Swal.fire({
        position: "center",
        icon: "success",
        title: "Saved successfully",
        showConfirmButton: false,
        timer: 5000,
      });
      setShowCheckboxModal(false);
    }
  } catch (error) {
    console.error("Error", error);
  } finally {
    setShowModal(false);
  }
};
  useEffect(() => {
  // Set time component of startDateObj and endDateObj to midnight
  const startDateObj = startDate ? new Date(startDate) : null;
  if (startDateObj) startDateObj.setHours(0, 0, 0, 0); // Set to midnight
  
  const endDateObj = endDate ? new Date(endDate) : null;
  if (endDateObj) endDateObj.setHours(23, 59, 59, 999); // Set to end of day (23:59:59.999)
  
  const filteredData = candidateData.filter(candidate => {
    const candidateDate = new Date(candidate.createdDate);
  
    // Check if candidate's fields match the filter criteria
    const fullNameMatch = candidate.fullName?.toLowerCase().includes(searchTerm.toLowerCase());
    const technologyMatch = candidate.technicalSkill?.toLowerCase().includes(searchTerm.toLowerCase());
    const roleMatch = candidate.jobRoleName?.toLowerCase().includes(searchTerm.toLowerCase());
    const locationMatch = candidate.preferLocation?.toLowerCase().includes(searchTerm.toLowerCase());
    const addressMatch = candidate.address?.toLowerCase().includes(searchTerm.toLowerCase());
  
    // Combine all conditions
    const nameTechnologyRoleMatch = fullNameMatch || technologyMatch || roleMatch || locationMatch || addressMatch;
    const dateRangeMatch =
      (!startDateObj || candidateDate.getTime() >= startDateObj.getTime()) && 
      (!endDateObj || candidateDate.getTime() <= endDateObj.getTime()); 
  
    return (nameTechnologyRoleMatch) && dateRangeMatch;
  });
      
    const slice = filteredData.slice(offset, offset + perPage);
    const items =  viewType =='grid' ? slice.map((data) => {
      const isChecked = selectedItems.some(item => String(item.guid) === String(data.guid));
      return (
        <div className="col-sm-12 col-md-6 col-xl-6 col-lg-6 pb-3" key={data.guid}>
             <div className="card mt-2" style={{ background: "#f8f8f8", border: '1px solid #00a7ac26', maxHeight: 600, height: 1000, borderRadius: 20 }}>
                <div className='card-header' style={{ background: "none", minHeight: 140 }}>
                  <div className='row'>
                                       <div className='col-8'>
                                          <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Full Name</Tooltip>)}>
                        <p className="card-title jb-head" style={{ color: "#00a7ac", fontSize: 24 }}><b>{data.fullName}</b></p>
                      </OverlayTrigger>
                      <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Job Role</Tooltip>)}>
                        <h5 style={{ fontSize: 18 }}>{data.jobRoleName}</h5>
                      </OverlayTrigger>
                    </div>
                  </div>
                </div>
                <div className="card-body" style={{minHeight:180}}>
                                 
               
                  <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Mobile Number</Tooltip>)}>
                    <p style={{ fontSize: 14 }}><i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fas fa-phone" aria-hidden="true"></i> {data.mobileNumber} </p>
                  </OverlayTrigger>
                  <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Email</Tooltip>)}>
                    <p style={{ fontSize: 14 }}><i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fas fa-envelope" aria-hidden="true"></i> {data.email}</p>
                  </OverlayTrigger>
                     <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>{data.technicalSkill}</Tooltip>)}>
                    <p style={{ fontSize: 14, textAlign: 'justify' }}>
                      <i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fa fa-code" aria-hidden="true"></i>
                      {substring_str(data.technicalSkill)}
                    </p>
                  </OverlayTrigger>
                  <OverlayTrigger
  placement="bottom"
  overlay={(props) => (
    <Tooltip id="tooltip" {...props}>
      {Array.isArray(data?.extractedResumeSkills) && data?.extractedResumeSkills?.length > 0
        ? data?.extractedResumeSkills
            .map(skill => skill.trim()) // Trim spaces
            .sort() // Sort alphabetically
            .join(", ")
        : data?.extractedResumeSkills }
    </Tooltip>
  )}
>
  <p style={{ fontSize: "14px" }}>
    <strong>Resume Skills:</strong>
    {substring_str(
      Array.isArray(data?.extractedResumeSkills) && data?.extractedResumeSkills?.length > 0
        ? data?.extractedResumeSkills
            .map(skill => skill.trim()) // Trim spaces
            .sort() // Sort alphabetically
            .join(", ")
        : data?.extractedResumeSkills
    )}
  </p>
</OverlayTrigger>

<OverlayTrigger
  placement="bottom"
  overlay={(props) => (
    <Tooltip id="tooltip" {...props}>
      {data?.extractedPostJobResults?.length > 0
        ? data?.extractedPostJobResults
            .map(skill => skill.trim()) // Trim spaces
            .sort() // Sort alphabetically
            .join(", ")
        : "No JD Skill"}
    </Tooltip>
  )}
>
  <p style={{ fontSize: "14px" }}>
    <strong>JD Skills:</strong>
    {substring_str(
      data?.extractedPostJobResults?.length > 0
        ? data?.extractedPostJobResults
            .map(skill => skill.trim()) // Trim spaces
            .sort() // Sort alphabetically
            .join(", ")
        : "Not Found"
    )}
  </p>
</OverlayTrigger>


<OverlayTrigger
  placement="bottom"
  overlay={(props) => (
    <Tooltip id="tooltip" {...props}>
      {data?.finalMatchedSkills?.length > 0
        ? data?.finalMatchedSkills
            .map(skill => skill.trim()) // Trim spaces
            .sort() // Sort alphabetically
            .join(", ")
        : "No Matched Skill"}
    </Tooltip>
  )}
>
  <p style={{ fontSize: "14px" }}>
    <strong>Matched Skills:</strong>
    {substring_str(
      data?.finalMatchedSkills?.length > 0
        ? data?.finalMatchedSkills
            .map(skill => skill.trim()) // Trim spaces
            .sort() // Sort alphabetically
            .join(", ")
        : "Not Found"
    )}
  </p>
</OverlayTrigger>

                <p style={{ fontSize: 14, fontWeight: "bold", color: "#00a7ac" }}>
                    <i className="fas fa-chart-line" style={{ marginRight: 10 }}></i>
                   <span style={{color:"#000",fontWeight:'normal'}}>Match Skills Percentage: </span>  {data.matchedSkillsPercentage}%
                </p>
                {/* <p style={{ fontSize: 14, fontWeight: "bold", color: "#00a7ac" }}>
                    <i className="fas fa-chart-line" style={{ marginRight: 10 }}></i>
                   <span style={{color:"#000",fontWeight:'normal'}}>Match Responsibilities Percentage: </span>  {data.extractedResponsibilitiesResults?.matchPercentage}%
                </p> */}

{data.extractedResponsibilitiesResults !== null && data.extractedResponsibilitiesResults !== "null" && 
data.extractedResponsibilitiesResults !== "[]" &&  <p style={{ fontSize: 14}}>
                    <i className="fa fa-info-circle icons" style={{ marginRight: 10 }}></i>
                   <span style={{color:"#000",fontWeight:'normal'}}>Match Responsibilities Reason: </span>
                   <div className="text-para">
      <ul>
        {(data?.extractedResponsibilitiesResults?.reasons)?.slice(0,2)?.map(reason => (
          <li  style={{ fontSize: "14px" }} key={reason.ReasonId}>{reason.reason}</li>
        ))}
      </ul>
    </div>    </p>
    }
                 </div>
                 <div className='card-footer d-flex justify-content-between'>
                 <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip">View</Tooltip>}>
  <button onClick={()=>{handleViewCandidate(data)}} style={{ background: "none", border: "none" }}>
    <i className="fa fa-eye mt-1" aria-hidden="true" style={{ fontSize: 20, color: "#00a7ac" }}></i>
  </button>
</OverlayTrigger>
<OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Select this and click on "Save Candidate" button to Save the comparision details</Tooltip>)}>

                                                 <input
          type="checkbox"
          checked={isChecked}
          onChange={(e) => handleCheckboxChange(data, e.target.checked)}
        />
        </OverlayTrigger>
                                                 <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Send Email</Tooltip>)}>
                                                         <button onClick={()=>handleEmailClick(data)} style={{ background: "none", border: "none" }}>
                                                             <i className="fa fa-envelope mt-1" aria-hidden="true" style={{ fontSize: 20, color: "#00a7ac" }}></i>
                                                         </button>
                                                     </OverlayTrigger>
                                                 </div>
   </div>
        </div>
      );
    }) :
        
    <div className="col-12 mt-2" style={{ overflowX: "auto", width: "100%" }}>
                              <table className="table" style={{ minWidth: "100%", fontSize: 14 }}>
                                    <thead>
                                      <tr>
                                        <th>Full Name</th>
                                        <th>Job Role</th>
                                     
                                        <th>Mobile Number</th>
                                        <th>Email</th>
                                        <th>Technical Skill</th>
                                        <th>Resume Skills</th>
                                        <th>JD Skills</th>
                                        <th>Matched Skills </th>
                                        <th>Match Skills Percentage</th>
                                        {showcolumn &&   <th>Match Responsibilities Reason</th>}
                                        <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                       {slice?.map((data, index) =>{
                                        const isChecked = selectedItems.some(item => String(item.guid) === String(data.guid));
                                        console.log("isChekd",isChecked)
          return ( 
                                        <tr key={index}>
                                          <td>{data.fullName}</td>
                                          <td>{data.jobRoleName}</td>                                        
                                          <td>{data.mobileNumber}</td>
                                          <td>{data.email}</td>
                                          <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>{data.technicalSkill}</Tooltip>)}>
                                          <td> {substring_str(data.technicalSkill)}</td>
                                          </OverlayTrigger>
                                          <OverlayTrigger
                                      placement="bottom"
                                      overlay={(props) => (
                                        <Tooltip id="tooltip" {...props}>
                                         {Array.isArray(data?.extractedResumeSkills) && data?.extractedResumeSkills?.length > 0
                                            ? data?.extractedResumeSkills
                                                .map(skill => skill.trim()) // Trim spaces
                                                .sort() // Sort alphabetically
                                                .join(", ")
                                            : data?.extractedResumeSkills}
                                        </Tooltip>
                                      )}
                                    >
                                      <td>
                                        {substring_str(
                                          Array.isArray(data?.extractedResumeSkills) && data?.extractedResumeSkills?.length > 0
                                            ? data?.extractedResumeSkills
                                                .map(skill => skill.trim()) // Trim spaces
                                                .sort() // Sort alphabetically
                                                .join(", ")
                                            : data?.extractedResumeSkills
                                        )}
                                      </td>
                                    </OverlayTrigger>

                                    <OverlayTrigger
                                      placement="bottom"
                                      overlay={(props) => (
                                        <Tooltip id="tooltip" {...props}>
                                          {data?.extractedPostJobResults?.length > 0
                                            ? data?.extractedPostJobResults
                                                .map(skill => skill.trim()) // Trim spaces
                                                .sort() // Sort alphabetically
                                                .join(", ")
                                            : "No JD Skill"}
                                        </Tooltip>
                                      )}
                                    >
                                      <td>
                                        {substring_str(
                                          data?.extractedPostJobResults?.length > 0
                                            ? data?.extractedPostJobResults
                                                .map(skill => skill.trim()) // Trim spaces
                                                .sort() // Sort alphabetically
                                                .join(", ")
                                            : "Not Found"
                                        )}
                                      </td>
                                    </OverlayTrigger>
                                                                              <OverlayTrigger placement="bottom" overlay={(props) => ( <Tooltip id="tooltip" {...props}>
                                         {Array.isArray(data?.finalMatchedSkills) && data?.finalMatchedSkills?.length > 0
                                            ? data?.finalMatchedSkills
                                                .map(skill => skill.trim()) // Trim spaces
                                                .sort() // Sort alphabetically
                                                .join(", ")
                                            : data?.finalMatchedSkills}
                                        </Tooltip>)}>

<td>

  {Array.isArray(data?.finalMatchedSkills) && data.finalMatchedSkills.length > 0
    ? data.finalMatchedSkills
        .map(skill => skill.trim())
        .sort()
        .join(", ")
    : "No Matched Skills"}
</td>
</OverlayTrigger>
                                          <td> {data.matchedSkillsPercentage}%</td>
                                          {/* <td> {data.extractedResponsibilitiesResults?.matchPercentage}%</td> */}
                                         
                                          {data.extractedResponsibilitiesResults !== null && data.extractedResponsibilitiesResults !== "null" && 
          data.extractedResponsibilitiesResults !== "[]" &&    
              <td>        <div className="text-para">
      {/* <i className="fa fa-info-circle icons"></i>{" "} */}
      <ul>
        {(data?.extractedResponsibilitiesResults?.reasons)?.slice(0,2)?.map(reason => (
          <li  style={{ fontSize: "14px" }} key={reason.ReasonId}>{reason.reason}</li>
        ))}
      </ul>
    </div>  </td>
           }
    <td>  
                                          <div style={{ display: "flex", gap: "5px", alignItems: "center" }}> 
                                          <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip">View</Tooltip>}>
  <button onClick={()=>{handleViewCandidate(data)}} style={{ background: "none", border: "none" }}>
    <i className="fa fa-eye mt-1" aria-hidden="true" style={{ fontSize: 20, color: "#00a7ac" }}></i>
  </button>
</OverlayTrigger>
<OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Select this and click on "Save Candidate" button to Save the comparision details</Tooltip>)}>

                                                 <input
          type="checkbox"
          checked={isChecked}
          onChange={(e) => handleCheckboxChange(data, e.target.checked)}
        />
        </OverlayTrigger>
                                                 <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Send Email</Tooltip>)}>
                                                         <button onClick={()=>handleEmailClick(data)} style={{ background: "none", border: "none" }}>
                                                             <i className="fa fa-envelope mt-1" aria-hidden="true" style={{ fontSize: 20, color: "#00a7ac" }}></i>
                                                         </button>
                                                     </OverlayTrigger>
                      </div>
                      </td>
                                         </tr>
                                       )})}
                                    </tbody>
                                  </table>
                                </div>

    setData(items);
    setPageCount(Math.ceil(filteredData.length / perPage));
  }, [offset, searchTerm,startDate,endDate,candidateData, perPage,viewType,selectedItems]);
  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setOffset(0); // Reset offset when search term changes to show results from the first page
  };

  const handleStartDateChange = (e) => {
    setStartDate(e.target.value);
  };

  const handleEndDateChange = (e) => {
    setEndDate(e.target.value);
  };
  const handleRefresh=()=>{
    setStartDate("")
    setEndDate("")
    setSearchTerm("")
  }

  return (
    <ConsultantLayout>
      <div className='container-fluid mt-3'>
      

<div class="responsive-container" style={{display:'flex',justifyContent:'space-between'}}>
                                 <div style={{ display: 'flex', alignItems: 'center' }}>
       <Link to="/Employer/ListOfJobPosts">
         <i className="fa fa-arrow-left" style={{ color: "#00a7ac", fontSize: 16, marginRight: '10px', marginTop: 8}} aria-hidden="true"></i>
       </Link>
       <h2 style={{ color: "#00a7ac", marginBottom: '0', marginTop: 8 }}>View Matched Candidates</h2>
     </div>
     {showIcon === 'grid' && (
                                  <OverlayTrigger placement="bottom" overlay={<Tooltip>List View</Tooltip>}>
                                    <button
                                      className="btn btn-primary"
                                      onClick={() => handleViewToggle('list')}
                                      style={{ backgroundColor: "#00a7ac" }}
                                    >
                                      <i className="fa fa-th-list" style={{ color: '#fff', cursor: 'pointer' }}></i>
                                    </button>
                                  </OverlayTrigger>
                                )}
                                {showIcon === 'list' && (
                                  <OverlayTrigger placement="bottom" overlay={<Tooltip>Grid View</Tooltip>}>
                                    <button
                                      className="btn btn-primary"
                                      onClick={() => handleViewToggle('grid')}
                                      style={{ backgroundColor: "#00a7ac" }}
                                    >
                                      <i className="fa fa-th" style={{ color: '#fff', cursor: 'pointer' }}></i>
                                    </button>
                                  </OverlayTrigger>
                                )}
        </div>
        <div>
 
        <div className="row d-flex justify-content-between mt-">
  <div className="col">
    <OverlayTrigger placement="bottom" overlay={(props) => (
      <Tooltip id="tooltip" {...props}>Search by Name or Technology or Role </Tooltip>
    )}>
      <input
        type="text"
        placeholder="Search by Name or Technology or Role"
        className="form-control mt-3"
        id="searchcss2"
        value={searchTerm}
        onChange={handleSearch}
      />
    </OverlayTrigger>
  </div>

  <div className="col">
    <OverlayTrigger placement="bottom" overlay={(props) => (
      <Tooltip id="tooltip" {...props}>Search by Start Date</Tooltip>
    )}>
      <input
        type="date"
        value={startDate}
        className="form-control basic-form mt-3"
        onChange={handleStartDateChange}
      />
    </OverlayTrigger>
  </div>

  <div className="col">
    <OverlayTrigger placement="bottom" overlay={(props) => (
      <Tooltip id="tooltip" {...props}>Search by End Date</Tooltip>
    )}>
      <input
        type="date"
        className="form-control basic-form mt-3"
        value={endDate}
        onChange={handleEndDateChange}
      />
    </OverlayTrigger>
  </div>

  <div className="col-auto align-self-end">
    <Link>
    <OverlayTrigger placement="bottom" overlay={(props) => (
      <Tooltip id="tooltip" {...props}>Reset</Tooltip>
    )}>
    <button className="btn btn-primary mt-3" onClick={handleRefresh} style={{height:50}}type="button">
      <i className="fas fa-sync"></i>
    </button>
    </OverlayTrigger>
    </Link>
  </div>
</div>

  </div>
 
        <hr />
     
        <div className="row mt-3 pb-3">
        {isAnalyzing && (
    <div className="text-center p-2" style={{backgroundColor:"#00a7ac"}}>
     <p style={{color:"#fff"}}> Please wait until analyzing is done, as it takes a few minutes...</p>
    </div>
  )}
    
          {isLoading ? <center><LoadingSpinner /></center> : <>
          <div>
          {selectedItems.length > 0 && (    <Button variant="primary" className='' style={{float:'right'}} onClick={openModal}>
            Save Candidates
          </Button>
        )}

{selectedItems.length > 0 && (    <Button variant="primary" className='' style={{float:'right',marginRight:8}} onClick={()=>setShowAnalyzeMoreModal(true)}>
          Analyze More
          </Button>
        )}
          </div>
          
         {data}
         </>}
        </div>
        {candidateData.length === 0 && (
  <div className="pb-5 text-center">
    <img title='No Data' className='no-data-img' src={nodataimg} style={{ height: 350 }} />
  </div>
)}
  
  {(candidateData.length === 0 )|| (data?.length===0) && (
  <div className="pb-5 text-center">
    <img title='No Data' className='no-data-img' src={nodataimg} style={{ height: 350 }} />
  </div>
)}
  
  <Modal show={showModal} onHide={() => setShowModal(false)}>
  <Modal.Header closeButton>
    <Modal.Title>Send Email</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <label>Client Email:</label>
    <input
      type="email"
      className="form-control"
      value={selectedClientEmail}
      onChange={(e) => setSelectedClientEmail(e.target.value)}
    />
  </Modal.Body>
  <Modal.Footer>
    <button className="btn btn-secondary" onClick={() => setShowModal(false)}>Cancel</button>
    <button className="btn btn-primary" onClick={handleSubmitEmail}>Send Email</button>
  </Modal.Footer>
</Modal>
<Modal show={showCheckboxModal} onHide={() => setShowCheckboxModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Submit Selected Candidates</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to submit the following selected candidates?</p>
          {selectedItems.map(item => (
            <div key={item.guid}>
              {item.fullName}
            </div>
          ))}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowCheckboxModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSaveCandidates}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showAnalyzeMoreModal} onHide={() => setShowAnalyzeMoreModal(false)}> 
  <Modal.Header closeButton>
    <Modal.Title>Analyze Selected Candidates</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <p>Are you sure you want to analyze more for the following selected candidates?</p>
    {selectedItems.length > 0 ? (
      selectedItems.map(item => (
        <div key={item.guid} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
          <span>{item.fullName}</span>
          <button
  className="btn btn-danger btn-sm"
  onClick={() => {
    handleCheckboxChange(item, false); // uncheck it visually
    handleRemoveCandidate(item.guid);  // remove from selectedItems
  }}
>
  <i className="fa fa-trash"></i>
</button>

        </div>
      ))
    ) : (
      <p className="text-muted">No candidates selected.</p>
    )}
  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={() => { setShowAnalyzeMoreModal(false); setShowColumn(false); }}>
      Cancel
    </Button>
    <Button variant="primary" onClick={handleProceed} disabled={selectedItems.length === 0}>
      Analyze
    </Button>
  </Modal.Footer>
</Modal>

        {
          candidateData.length > perPage &&
          <ReactPaginate
            previousLabel={"Prev"}
            nextLabel={"Next"}
            breakLabel={"..."}
            breakClassName={"break-me"}
            pageCount={pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={10}
            onPageChange={handlePageClick}
            containerClassName={"pagination"}
            subContainerClassName={"pages pagination"}
            activeClassName={"active"}
            disabledClassName={"disable-pagination-button"}
          />
        }


      </div>
    </ConsultantLayout>
  );
}

export default ViewMatchedCandidates;


